export class Controller {

    /** @ngInject */
    constructor($state) {
        this.$state = $state;
    }

    $onChanges() {
        if (this.companyUserId) {
            this.href = this.$state.href(
                'company.user-directories.manage-user',
                {companyUserId: this.companyUserId}
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/portal/components/sp-company-user-label/sp-company-user-label.controller.js